export const COMPLIANCE_STATUS_APPROVED = 'approved';
export const COMPLIANCE_STATUS_PENDING = 'pending';
export const COMPLIANCE_STATUS_REJECTED = 'rejected';

const COMPLIANCE_ERROR_MESSAGES: Record<string, string> = {
  [COMPLIANCE_STATUS_PENDING]:
    'Tu cuenta está pendiente de aprobación de cumplimiento. No puedes crear operaciones hasta que sea aprobada.',
  [COMPLIANCE_STATUS_REJECTED]:
    'Tu cuenta fue rechazada por cumplimiento. Contacta a soporte para revisar tu cuenta.',
};

export function normalizeComplianceStatus(status: unknown): string {
  const normalized = String(status ?? '').trim().toLowerCase();
  return normalized || COMPLIANCE_STATUS_PENDING;
}

export function getComplianceBlockedMessage(status: unknown): string {
  const normalized = normalizeComplianceStatus(status);
  return (
    COMPLIANCE_ERROR_MESSAGES[normalized] ??
    `Tu cuenta no está aprobada por cumplimiento. Estado actual: ${normalized}.`
  );
}
